import { Injectable } from '@angular/core';
import { components } from '../schema/backend';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';


const SDTM_PLACEHOLDER = `Please provide additional information for SDTM creation...`;

type DomainSelection = components['schemas']['SdtmWorkflowState']['selections'];
type OsbStateType = components['schemas']['OsbState'];
export type SDTMSelections = {
  [category: string]: DomainSelection;
};

export type SDTMWorkflow = {
  type: 'sdtm',
  label: "SDTM Automation",
  inpPlaceholder: string,
  data: {
    selections: SDTMSelections,
    specInfo: string
  }
};

export type USDMWorkflow = {
  type: 'usdm',
  label: "USDM Automation",
  inpPlaceholder: string,
  data: {
    protocolFilePath: string | null,
    osbStudyUid: string | null,
    osbServerUrl: string | null,
    osbStates: OsbStateType[]
  }
};

export type WorkflowKey = keyof WorkflowTypeMap;
export type WorkflowType = WorkflowTypeMap[WorkflowKey];

export type WorkflowTypeMap =
  { usdm: USDMWorkflow } &
  { sdtm: SDTMWorkflow, usdm: USDMWorkflow };

export type WorkflowUpdate = {
  message: string,
  type: 'info' | 'error' | 'success'
}

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  private currentWorkFlow = new BehaviorSubject<WorkflowType | null>(null);
  currentWorkFlow$ = this.currentWorkFlow.asObservable();

  workflowOptions: WorkflowTypeMap = {} as WorkflowTypeMap;
  scriptsDir: string = '/workspace/scripts/sdtm-cols/';

  constructor() {
    // Always include USDM
    this.workflowOptions.usdm = {
      type: 'usdm',
      label: "USDM Automation",
      inpPlaceholder: 'Please provide additional information for USDM creation...',
      data: {
        protocolFilePath: null,
        osbStudyUid: null,
        osbServerUrl: null,
        osbStates: []
      }
    };

    // Only include SDTM when not in production
    if (!environment.production) {
      this.workflowOptions.sdtm = {
        type: 'sdtm',
        label: "SDTM Automation",
        inpPlaceholder: SDTM_PLACEHOLDER,
        data: {
          selections: {},
          specInfo: ''
        }
      };
    }
  }
  setWorkflow(workflow: WorkflowType | null) {
    this.currentWorkFlow.next(workflow);
    // console.log('Workflow set to:', workflow);
  }
}
